<template>
  <v-container
    fill-height
    fluid
  >
    <v-flex
      v-if="!$apollo.loading"
    >
      <v-card>
        <v-row>
          <v-col 
            cols="12"
          >
            <v-row
              class="dates-toolbar"
              align="end"
              justify="end"
            >
              <v-col
                cols="4"
                sm="4"
                md="2"
              >
                <v-menu
                  v-model="PickerFrom"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="fromDate"
                      :label="$t('globals.from')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker 
                    v-model="params.fromDate" 
                    :locale="$i18n.locale"
                    min="2017-05-01"
                    :max="params.toDate || $moment().format('YYYY-MM-DD')"
                    @input="PickerFrom = false"
                    @change="reload(params.fromDate, 'fromDate')"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="4"
                sm="4"
                md="2"
              >
                <v-menu
                  v-model="PickerTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="toDate"
                      :label="$t('globals.to')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker 
                    v-model="params.toDate" 
                    :locale="$i18n.locale"
                    :min="params.fromDate || '2017-05-01'"
                    :max="$moment().format('YYYY-MM-DD')"
                    @input="PickerTo = false"
                    @change="reload(params.toDate, 'toDate')"
                  />
                </v-menu>
              </v-col>
            </v-row>
            <v-data-table  
              v-if="!_.isEmpty(transactions.data)" 
              :class="$vuetify.breakpoint.xs ? '' : 'text-no-wrap'" 
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100, 200]
              }"
              :locale="$i18n.locale"
              :items="transactions.data"
              :items-per-page="transactions.per_page"
              :page="transactions.current_page"
              :server-items-length="transactions.total"
              :hide-default-footer="_.isEmpty(transactions.data)"
              dense
              @update:items-per-page="reload($event, 'count')"
              @update:page="reload($event, 'page')"
            >
              <template v-slot:item.created_at="{ item }">
                <small>{{ item.created_at | moment('L LT') }}
                </small>
              </template> 
              <template v-slot:item.payment_subject="{ item }">
                <small>
                  {{ $t('transactions.'+item.payment_subject) }}{{ item.note != null ? ', '+ item.note : '' }}
                </small>
              </template> 
          
              <template v-slot:item.amount_in="{ item }">
                <b>{{ item.amount_in !== null ? item.amount_in : '-'+item.amount_out }} {{ item.currency }}</b>
              </template>
            </v-data-table>
          </v-col>
          <v-col
            v-if="_.isEmpty(transactions.data)" 
            class="not-found"
          >
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('transactions.notFound') }}</p>
          </v-col>
        </v-row>  
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>

const TRANSACTIONS_QUERY = require('@/graphql/queries/Transactions.gql');


export default {
  name: 'Transactions',
  data() {
    return {
      PickerFrom: null,
      PickerTo: null,
      loading: false,
      params: {
        fromDate: this.$moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
        toDate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        page: 1,
        count: 25
      },
      headers: [
        {
          sortable: false,
          text: this.$t('transactions.date'),
          value: 'created_at'
        },
        {
          sortable: false,
          text: this.$t('transactions.description'),
          value: 'payment_subject'
        },
        {
          sortable: false,
          text: this.$t('accounts.inOut'),
          value: 'amount_in'
        }
        
      ]
    }
    
  },
  computed: {
    fromDate() {
      return this.$moment(this.params.fromDate).format('ll');
    },
    toDate() {
      return this.$moment(this.params.toDate).format('ll');
    }
  },
  methods: {
    reload(value, from) {
      this.params[from] = value
      this.params.fromDate = this.$moment(this.params.fromDate).format('YYYY-MM-DD HH:mm:ss')
      this.params.toDate = this.$moment(this.params.toDate).format('YYYY-MM-DD HH:mm:ss')
      this.$apollo.queries.transactions.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      })
    },
  },
  apollo: {
    transactions: {
      query: TRANSACTIONS_QUERY,
      fetchPolicy: 'network',
      variables() {
        return this.params
      }
    }
  }
}
</script>

<style lang="scss">


</style>
